import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";

export const Footer = () => (
  <footer className="border-t border-line bg-ink-900">
    <div className="mx-auto max-w-7xl px-5 md:px-8 py-14">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
        <div>
          <Logo />
          <p className="mt-4 text-white/45 text-sm max-w-sm">
            Premium truck, trailer, fleet and building signage for Australia's transport and
            construction industry.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-sm text-white/60">
          <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-orange transition-colors">{CONTACT.phone}</a>
          <span>{CONTACT.area}</span>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-line flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/35">
        <span>© {new Date().getFullYear()} AUS/SIGNS. All rights reserved.</span>
        <div className="flex gap-4">
          <span>Truck Signage · Trailer Signage · Fleet Wraps · Building Signage · Australia Wide</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-orange transition-colors">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
